export const LANDING_PAGE_AI_PROMPT_BOX_ID = 'l-ai-chat-prompt-box';
